<h1 class="mb-3" [class.text-center]="textCenter" [class.text-end]="textRight">
  <ng-content></ng-content>
</h1>
